import React, { useState } from 'react';
import { X } from 'lucide-react';

const DomainNameModal = ({ isOpen, onClose, onConfirm }) => {
  const [domainName, setDomainName] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (domainName.trim()) {
      onConfirm(domainName.trim());
      setDomainName('');
    }
  };

  const handleClose = () => {
    setDomainName('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold text-gray-900">
            Enter Domain Name
          </h3>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-600"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Domain Name
            </label>
            <input
              type="text"
              value={domainName}
              onChange={(e) => setDomainName(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500"
              placeholder="e.g., greencafe.com, techsolutions.net"
              autoFocus
            />
            <p className="text-xs text-gray-500 mt-1">
              This will inspire the AI to generate a business related to your domain name
            </p>
          </div>
          
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!domainName.trim()}
              className="px-4 py-2 bg-purple-600 text-white rounded-md hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Generate Business
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DomainNameModal;